/**
* @name APP ClassPanel
* @autor jaime.salazar@u-planner.com
* @description
* # name controller --> dialogSummaryControllers
* # As Controller --> dialogSummary
* brief comment controller for show dialog finish approval
                                                        
*/

export default class perfil_popcontroller{

	constructor($scope,	$http,$resource,$filter,ngNotify,$mdDialog, datos){
        this.$mdDialog = $mdDialog;
        this.$scope = $scope;
        this.$scope.datos = datos;
    }

    close(){
        this.$mdDialog.hide();
    }
}

perfil_popcontroller.$inject = ['$scope', '$http', '$resource', '$filter', 'ngNotify', '$mdDialog','datos'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_dash/dialog/perfil_popcontroller.js